import types from "./types";
const initialState = { value: "", label: "" };
const cityReducer = (state = initialState, action) => {
 
  switch (action.type) {
    case types.CITY_VALUE:
      return { ...state, value: action.city.value, label: action.city.label };

    default:
      return state;
  }
};

export default cityReducer;
